import './uploaded-image.less';
import uploadedImageTemplate from './uploaded-image.tpl.html';
import { cloudinaryServiceModule } from '../../services/cloudinary-service/cloudinary-service';

export const uploadedImageComponentModule = angular
  .module('Q.components.uploaded-image', [cloudinaryServiceModule])

  .directive('uploadedImage', function (cloudinaryService) {
    return {
      restrict: 'AE',
      scope: {
        file: '=',
        size: '=',
        hardcodeSize: '=',
        defaultSrc: '@',
        width: '=?',
        height: '=?',
      },
      replace: true,
      template: uploadedImageTemplate,
      link(scope) {
        scope.$watch('file.fileId || file', () => {
          if (scope.file) {
            scope.url = cloudinaryService.getUrl(scope.file, {
              width: scope.width,
              height: scope.height,
              retina: true,
            });
          } else if (scope.defaultSrc) {
            scope.url = scope.defaultSrc;
          }
        });
        scope.width = scope.width || scope.size || 100;
        scope.imageWidth =
          scope.hardcodeSize === false ? '' : scope.width + 'px';
        scope.imageHeight =
          scope.hardcodeSize === false
            ? ''
            : (scope.height || scope.width) + 'px';
      },
    };
  });
